import { render } from "./StickyAddToBagV2.vue?vue&type=template&id=4cf3a346&scoped=true"
import script from "./StickyAddToBagV2.vue?vue&type=script&lang=js"
export * from "./StickyAddToBagV2.vue?vue&type=script&lang=js"

import "./StickyAddToBagV2.vue?vue&type=style&index=0&id=4cf3a346&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf3a346"]])

export default __exports__